import type { ReactNode } from 'react';
import DOMPurify from 'isomorphic-dompurify';
import classNames from 'classnames';
import styles from './fallbackProductDescription.module.scss';
import { useTranslation } from 'next-i18next';
import { IbhProductionMethods } from '@igus/iglidur-bearing-hub-api/src/data-contracts';

type FallbackProductDescriptionProps = {
  materialName: string;
  productionMethod?: IbhProductionMethods;
};
export const FallbackProductDescription = ({
  materialName,
  productionMethod,
}: FallbackProductDescriptionProps): ReactNode => {
  const { t } = useTranslation(['common', 'product/productDetails']);

  if (!materialName) {
    return null;
  }

  const normalizeMaterialName =
    productionMethod === IbhProductionMethods.SEMIFINISHED ? materialName.replace(/-CNC/g, '') : materialName;

  const rawHtml = t(`${normalizeMaterialName}`, { ns: 'free-form-hub/materialsDescription', defaultValue: '' });
  const cleanHtml = DOMPurify.sanitize(rawHtml, {
    FORBID_ATTR: ['style'],
  });

  return (
    <div>
      <span className="text-[16px] font-bold pb-2.5">
        {!cleanHtml.length && t(`MATERIALS.${normalizeMaterialName}_DESCRIPTION`, { ns: 'free-form-hub/materials' })}
      </span>
      {/* eslint-disable-next-line react/no-danger */}
      <div className={`${classNames(styles.productDescription)}`} dangerouslySetInnerHTML={{ __html: cleanHtml }} />
    </div>
  );
};
